export class RequestDay {
    ID?: number;
    RequestID?: number;
    DayOfWeekID: number;
    DayTypeID: number;
}

export default RequestDay;